import { useEffect } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import { getDishDetails, getBalancedDishDetails } from '../../actions/menus';
import { unitTypeLabels } from '../../constants/questioner';
import { buildSourceURL } from '../../utils/functions';
import VideoButton from '../VideoButton/VideoButton';
import styles from './DishesPage.module.css';

const DishDetails = (props) => {
  const {
    dishId,
    day,
    children,
    getDishDetails,
    getBalancedDishDetails,
    isBalanced,
    dish,
    onBack,
  } = props;

  console.log('=== dishDetails', dish);

  useEffect(() => {
    if (isBalanced) {
      getBalancedDishDetails(dishId, day);
    } else {
      getDishDetails(dishId);
    }
  }, [dishId]);

  if (!dish) {
    return null;
  }

  return (
    <div className={cn(styles.wrapper, styles.detailsWrapper)}>
      <div className={styles.dishDetailsHeader}>
        <img 
          className={styles.dishDetailsImage}
          src={buildSourceURL(dish.image)} 
          alt={dish.name} 
        />
        <div className={styles.backButton} onClick={onBack} />
        {dish.meal_name !== 'snack' && (
          <VideoButton 
            className={styles.watchVideoTopButton}
            source={buildSourceURL(dish.video)}
          />
        )}
        {/* <div className={styles.watchVideoTopButton} /> */}
      </div>
      <div className={styles.dishDetailsContent}>
        <div className={styles.dishDetailsMeal}>
          {dish.meal_name}
        </div>
        <div className={styles.dishDetailsName}>
          {dish.name}
        </div>
        <div className={styles.dishDetailsBadges}>
          <div className={cn(styles.dishDetailsBadge, styles.cookingTime)}>
            Cooking time: {dish.cooking_time} min
          </div>
          {!!dish.gluten_free && (
            <div className={styles.cookingTime}>
              Gluten Free
            </div>
          )}
          <div className={cn(styles.dishDetailsBadge, styles.difficulty)}>
            {dish.difficulty}
          </div>
        </div>
        <div className={styles.dishDetailsNutrition}>
          <div className={styles.dishDetailsCalories}>
            {+dish.nutrients.calories.toFixed(1)} kcal
          </div>
          <div className={styles.dishDetailsNutritionItems}>
            <div className={styles.dishDetailsNutritionItem}>
              <div className={styles.dishDetailsNutritionInfo}>
                <div>
                  Protein
                </div>
                <div>
                  {+dish.nutrients.protein.toFixed(1)} g
                </div>
              </div>
            </div>
            <div className={styles.dishDetailsNutritionItem}>
              <div className={styles.dishDetailsNutritionInfo}>
                <div>
                  Fat
                </div>
                <div>
                  {+dish.nutrients.fat.toFixed(1)} g
                </div>
              </div>
            </div>
            <div className={styles.dishDetailsNutritionItem}>
              <div className={styles.dishDetailsNutritionInfo}>
                <div>
                  Carbs
                </div>
                <div>
                  {+dish.nutrients.carbohydrates.toFixed(1)} g
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.dishDetailsIngredientsBlock}>
          {dish.components.map((component, index) => (
            <div key={index} className={styles.dishDetailsComponentIngredient}>
              <div className={styles.dishDetailsComponentName}>
                {component.name}
              </div>
              <div className={styles.dishDetailsIngredients}>
                {component.ingredients.map((ingredient, index) => (
                  <div key={index} className={styles.dishDetailsIngredient}>
                    {ingredient.name}
                    <span className={styles.dishDetailsIngredientAmount}>
                      {ingredient.amount || ''} {unitTypeLabels[ingredient.unit_type]}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className={styles.watchVideoButton}>
          Watch recipe video
        </div>
        <div className={styles.dishDetailsInstructionsBlock}>
          {dish.components.map((component, index) => (
            <div key={index} className={styles.dishDetailsComponentInstruction}>
              <div className={styles.dishDetailsComponentTitle}>
                {component.title}
              </div>
              <div className={styles.dishDetailsInstruction}>
                {component.instruction}
              </div>
            </div>
          ))}
          {dish.serving && (
            <div className={styles.dishDetailsComponentInstruction}>
              <div className={styles.dishDetailsComponentTitle}>
                Serving
              </div>
              <div className={styles.dishDetailsInstruction}>
                {dish.serving}
              </div>
            </div>
          )}
        </div>
      </div>
      {!!children && (
        <div className={styles.detailsBottomButtons}>
          {children}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  dish: state.menus.dishDetails,
});
const mapDispatchToProps = {
  getDishDetails,
  getBalancedDishDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(DishDetails);